import { useEffect, useState } from "react";

//redux
import { useSelector } from "react-redux";

//components
import ModalBase from "./ModalBase";
import ProductModalContent from "./content/ProductModalContent";

const ProductModal = ({}) => {
	const [product, setProduct] = useState({});
	const [isLoading, setIsLoading] = useState(false);

    const productId = useSelector((state) => state.chat_modals.entries?.product?.data?.productId);

    const fetchProduct = async (productId) => {
        setIsLoading(true);
        try {
            const response = await __cng_common.api_service.get(`/get_product_with_options?pid=${productId}`);
            setProduct(response.data);
        } catch (error) {
            console.error("Error fetching product:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!productId) {
			setProduct({});
			setIsLoading(false);
			return;
		}
        fetchProduct(productId);
    }, [productId]);

	return (
		<ModalBase modalKey='product'>
			<ProductModalContent product={product} isLoading={isLoading} />
		</ModalBase>
	);
};

export default ProductModal;
